import { GraphQLError } from 'graphql/error'

export function isExternallyReportedError(error: GraphQLError) {
  const errorCode = error?.extensions?.code

  const externallyReportedError =
    errorCode === 'DOWNSTREAM_SERVICE_ERROR' || errorCode === 'INTERNAL_SERVER_ERROR'
  return externallyReportedError
}
